import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class ToastMessagesService {

  constructor(public snackBar: MatSnackBar) {
  }

  toastMessages(message: string) {
    this.snackBar.open(message, '', {
      duration: 5000,
    });
  }

  toastErrorMessage(message: string) {
    this.snackBar.open(`Κάτι πήγε στραβά: ${message}`, '', {
      duration: 5000,
    });
  }

  toastUpdateSuccess() {
    this.snackBar.open(`Η ενημέρωση ολοκληρώθηκε με επιτυχία`, '', {
      duration: 5000,
    });
  }

  toastInsertSuccess() {
    this.snackBar.open(`Η προσθήκη ολοκληρώθηκε με επιτυχία`, '', {
      duration: 5000,
    });
  }

  toastDeleteSuccess() {
    this.snackBar.open(`Η διαγραφή ολοκληρώθηκε με επιτυχία`, '', {
      duration: 5000,
    });
  }
}
